import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { SalesOrders_ModuleContextService } from './SalesOrders.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class SalesOrders_order_total_picked_units_by_date_widget_ComponentContextService {
  private readonly moduleContext: SalesOrders_ModuleContextService;

  constructor(moduleContext: SalesOrders_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'order_total_picked_units_by_date_widget',
      type: ComponentType.widget
    }
  }
}